var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal-with-custom-content",
    {
      ref: "modal",
      staticClass: "px-5",
      attrs: { modalId: _vm.modalId, hideBottomCloseButton: true }
    },
    [
      _c("div", { staticClass: "d-flex flex-column justify-content-center" }, [
        _c("p", { staticClass: "text-md-center" }, [
          _vm._v(_vm._s(_vm.description))
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "modal-buttons m-auto" },
          [
            _c("button-with-loading-component", {
              staticClass:
                "btn btn-secondary btn-confirmation disable-dark mr-2",
              attrs: {
                text: _vm.confirmText || _vm.translate.home.yes,
                "e2e-id": "confirmation-modal-yes-btn"
              },
              nativeOn: {
                click: function($event) {
                  return _vm.onConfirm($event)
                }
              }
            }),
            _vm._v(" "),
            _c("button-with-loading-component", {
              staticClass: "btn btn-primary btn-confirmation disable-dark",
              attrs: {
                text: _vm.cancelText || _vm.translate.home.no,
                "e2e-id": "confirmation-modal-no-btn"
              },
              nativeOn: {
                click: function($event) {
                  return _vm.onCancel($event)
                }
              }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e41358d", { render: render, staticRenderFns: staticRenderFns })
  }
}